import React, { Component } from "react"
import logo from "../../../assets/images/logo.png"
import admin from "../../../assets/images/admin-card-img.png"
import teacher from "../../../assets/images/teacher-card-img.png"
import student from "../../../assets/images/student-card-img.png"
import "./LandingPage.css"
import { history } from "../../../helper/history"
import { routes } from "../../../helper/routes"
import edfocilogo from "../../../assets/images/logo.png";
import edsiderlogo from "../../../assets/images/edsiderlogo.png";
import cmclogo from "../../../assets/images/mid.png";
import RAlogo from "../../../assets/images/royal-logo.png";
import CGClogo from "../../../assets/images/cgc-logo.png";
import IEA_logo from "../../../assets/images/IEA_logo.png";
import AEHSlogo from "../../../assets/images/AEHS-Logo.png";
import SIT_logo from "../../../assets/images/SIT_logo.png";
import config from "../../../helper/config";
import { customerConstants } from "../../../helper/constants.js";
import { Margin, Padding } from "@mui/icons-material";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

export default class LandingPage extends Component {
  handleRoleSelect = (role) => {
    sessionStorage.setItem("user_role_selection", role)
    history.push(routes.auth_response)
  }
  render() {
    const customer = getCustomerFeatureFlag();
    let logo, logoStyle, logoStyle2 = false;
    let institutename;
    switch (customer) {
      case customerConstants.EXO_CUSTOMER1:
        logo = edsiderlogo;
        logoStyle = { width: "140px", height: "auto" };
        institutename = "EdFoci";
        break;
      case customerConstants.EXO_CUSTOMER2:
        logo = cmclogo;
        logoStyle = { width: "190px", height: "auto" };
        institutename = "EdFoci";
        break;
      case customerConstants.EDF_CUSTOMER2:
        logo = RAlogo;
        logoStyle = { width: "40px", height: "auto" };
        institutename = "EdFoci";
        break;
      case customerConstants.EDF_CUSTOMER3:
        logo = CGClogo;
        logoStyle = { width: "64px", height: "auto", Padding: '2px' };
        institutename = "EdFoci";
        logoStyle2 = true;
        break;
      case customerConstants.EDF_CUSTOMER4:
        logo = AEHSlogo;
        logoStyle = { width: "150px", height: "auto", Padding: '2px' };
        institutename = "EdFoci";
        logoStyle2 = true;
        break;
      case customerConstants.EDF_CUSTOMER5:
        logo = IEA_logo;
        logoStyle = { width: "150px", height: "auto", Padding: '2px' };
        institutename = "Impact English Academy";
        break;
      case customerConstants.EDF_CUSTOMER6:
        logo = SIT_logo;
        logoStyle = { width: "150px", height: "auto", Padding: '2px' };
        institutename = "School of Information Technology";
        break;
      default:
        logo = edfocilogo;
        logoStyle = { width: "140px", height: "auto" };
        institutename = "EdFoci";
        break;
    }
    return (
      <>
        <div className="landing-bg">
          <div className="container pb-5">
            <div className="row py-5">
              {/* <img className="logo-img" src="https://str4edfdevwebapp.blob.core.windows.net/images/Group 31 1 (1) (1).png" alt="Logo" /> */}
            <img
                  alt="Logo"
                  className="logo"
                  src={logo}
                  style={logoStyle}
                />
            </div>
            <div className="row pt-4 mb-10 ml-0 mr-0 justify-content-center">
              <h1 className="col-md-12 d-flex justify-content-center landing-topic">
                Welcome to {institutename}!
              </h1>
              <p className="col-md-12 d-flex justify-content-center landing-para">
                Sign In to continue to your account
              </p>
              <span className="d-flex justify-content-center underline-container">
                <div className="landing-para-underline"></div>
              </span>
            </div>
            <div className="row py-5 pt-4">
              <div className="col-md-4 d-flex justify-content-center">
                <div className="card landing-card mt-3">
                  <img className="card-img-top landing-card-img" src={admin} alt="admin-img" />
                  <div className="landing-card-body">
                    <center>
                      <button
                        type="button"
                        className="btn landing-btn my-2"
                        onClick={() => this.handleRoleSelect("admin")}
                      >
                        As an Administrator
                      </button>
                    </center>
                  </div>
                </div>
              </div>
              <div className="col-md-4 d-flex justify-content-center">
                <div className="card landing-card mt-3">
                  <img
                    className="card-img-top landing-card-img"
                    src={teacher}
                    alt="teacher-img"
                  />
                  <div className="landing-card-body">
                    <center>
                      <button
                        type="button"
                        className="btn landing-btn my-2"
                        onClick={() => this.handleRoleSelect("teacher")}
                      >
                        As a Teacher
                      </button>
                    </center>
                  </div>
                </div>
              </div>
              <div className="col-md-4 d-flex justify-content-center">
                <div className="card landing-card mt-3">
                  <img
                    className="card-img-top landing-card-img"
                    src={student}
                    alt="student-img"
                  />
                  <div className="landing-card-body">
                    <center>
                      <button
                        type="button"
                        className="btn landing-btn my-2"
                        onClick={() => this.handleRoleSelect("student")}
                      >
                        As a Student
                      </button>
                    </center>
                  </div>
                </div>
              </div>
            </div>
            <div className="row my-5 d-flex justify-content-center">
              <p className="text-center copyRightText">
                © 2024 All Rights Reserved. Designed and Developed by Infinity
                Innovators (Pvt) Ltd
              </p>
            </div>
          </div>
        </div>
      </>
    )
  }
}
